import Vue from 'vue';
import {
  messageFormat2,
  formatDateTime,
} from "../../utils/ChatUtils";
import store from "@/store";
import Audio from "../../utils/Audio";
import EventBus from "@/utils/eventBus";
import conf from "../../views/im/conf/index.js";
import RequestUtils from "../../utils/RequestUtils";

export default{
  namespaced: 'shopee', //具名引用时使用
  state: {                 //state状态管理(通过store.state.name访问)
    token: {},
    // 当前的用户
    user: {},
    websocket: {},

    messageList: [],
    // 当前聊天窗口
    currentChat: {},
    // 所有的聊天窗口
    chatList: [],
    //刷新token 定时器
    flushTokenTimerId: null,

    socket: {
      isConnected: false,
      message: '',
      reconnectError: false,
    },
    storeList: [],
    storeData: {},
    sessionData: {},
    messageData: {},
    currentSessionData: {},
    currentSession: {},
    currentStore: {},
    sellerData: {},
    orderData: {},
    productData: {},
    voucherData: {},
    searchSession: {},
    sessionTab: ['invition', 'recently']
  },
  getters: {               // state的计算属性(通过store.getters.lastName访问)    

  },
  mutations: {          // mutations改变store的状态（通过store.commit('SET_NAME', 'qian')提交修改）
    setStoreList: function (state, storeList) {
      let storeOpt = [{
        'id': 0,
        'name': '全部',
        'active': true
      }]
      for (let i=0; i<storeList.length; i++) {
        Vue.set(state.storeData, storeList[i]['shop_id'], {unread_count: 0});
        Vue.set(state.sessionData, storeList[i]['shop_id'], {invition: {}, recently: {}});
        Vue.set(state.messageData, storeList[i]['shop_id'], {});
        Vue.set(state.orderData, storeList[i]['shop_id'], {});
        Vue.set(state.productData, storeList[i]['shop_id'], {});
        Vue.set(state.voucherData, storeList[i]['shop_id'], {});
        storeList[i]['unread_count'] = 0;
        storeList[i]['transfer_count'] = 0;
        storeOpt.push({
          'id': storeList[i].id,
          'name': storeList[i].name,
        })
      }
      state.currentStore = storeList[0];
      state.storeList = storeList;
      // set option
      store.state.storeOpt['shopee'] = storeOpt;
    },
    // 设置店铺属性
    setStoreAttr: function (state, data) {
      for (let i=0; i<state.storeList.length; i++) {
        if (state.storeList[i].id == data.id) {
          if (data.attr) {          
            state.storeList[i][data.attr] = data.value;
          } else {
            state.storeList[i] = data;
          }
          break;
        }
      }
    },
    setSessionData: function (state, sessionData) {
      Vue.set(state.sessionData, sessionData.store.shop_id, sessionData);

      this.commit("shopee/sortSessionList", {shop_id: sessionData.store.shop_id});
      this.commit("shopee/calcStoreUnread", sessionData.store.shop_id);
    },
    // 设置已分配数据
    setRecentlyData: function (state, data) {
      let shop_id = state.currentStore.shop_id;
      state.sessionData[shop_id]['recently'] = data;
    },
    setCurrentSessionData: function (state, session) {
      Vue.set(state.currentSessionData, state.currentStore.shop_id, session);
    },
    setSessionDataBySid: function (state, session) {
      for (let j=0; j<state.sessionTab.length; j++) {
        let session_list = state.sessionData[state.currentStore.shop_id][state.sessionTab[j]].data;
        for (let i=0; i < session_list.length; i++)
        {
          if (session_list[i].conversation_id == session.conversation_id) {
            state.sessionData[state.currentStore.shop_id][state.sessionTab[j]].data[i] = session;
            this.commit("shopee/calcStoreUnread", state.currentStore.shop_id);
            break;
          }
        }
      }
    },
    // 设置消息列表
    setMessageData: function (state, messageData) {
      let self = this;
      let currentSession = state.currentSessionData[state.currentStore.shop_id];
      let dealMsg = new Array();

      messageData.messages = messageData.messages.map(function(elem) {
        elem.format_content = messageFormat2(elem.message_type, elem.content);
        elem.sys_notice = elem.message_type == 'notification' ? 1 : 0;
        elem.timestamp = formatDateTime(new Date(elem.created_timestamp));
        if (elem.from_id != currentSession.to_id) {
          elem.avatar = state.currentStore.logo_url;
        } else {          
          elem.avatar = currentSession.to_avatar;
        }
        if (elem.source_content.item_id && elem.message_type != 'offer') {
          elem.productOfConsult = {
            shop_id: '',
            item_id: '',
            images: [],
            name: '-',
            original_price: '-',
            price: '-',
            stock: '-'
          }
        } else if (elem.source_content.order_sn) {
          elem.orderOfConsult = {
            shop_id: '',
            item_id: '',
            images: [],
            name: '-',
            original_price: '-',
            price: '-',
            stock: '-'
          }
        }
        if ((elem.source_content.item_id && elem.message_type != 'offer') || elem.source_content.order_sn) {
          dealMsg.push(elem);
        }
        return elem;
      });
      state.messageData[state.currentStore.shop_id] = messageData;
      messageData.messages.map(function(elem) {
        self.commit("shopee/msgCallback", elem);
      })
      for (let i=0; i<dealMsg.length; i++) {
        if (dealMsg[i].source_content.item_id) {
          let param = new FormData();
          param.set("store_id", state.currentStore.id);
          param.set("item_id", dealMsg[i].source_content.item_id);
          RequestUtils.request(conf.getProductInfo(), param).then(json => {
            dealMsg[i].productOfConsult = json;
          })
        } else if (dealMsg[i].source_content.order_sn) {
          let param = new FormData();
          param.set("store_id", state.currentStore.id);
          param.set("order_sn", dealMsg[i].source_content.order_sn);
          RequestUtils.request(conf.getOrder(), param).then(json => {
            dealMsg[i].orderOfConsult = json;
          })
        }
      }
      if (store.state.translate) {
        this.commit("shopee/getTransMessage");
      }
    },
    setCurrentStore: function (state, currentStore) {
      state.currentStore = currentStore;
    },
    setCurrentSession: function (state, currentSession) {
      state.currentSession = currentSession;
    },
    // 添加会话列表
    pushSessionList: function (state, sessionData) {
      let shop_id = sessionData.shop_id;
      let tab = sessionData.tab;
      for (let i=0; i<sessionData.data.data.length; i++)
      {      
        state.sessionData[shop_id][tab].data.push(sessionData.data.data[i]);
      }
      state.sessionData[shop_id][tab].total = sessionData.data.total;
      state.sessionData[shop_id][tab].per_page = sessionData.data.per_page;
      state.sessionData[shop_id][tab].current_page = sessionData.data.current_page;
      state.sessionData[shop_id][tab].last_page = sessionData.data.last_page;
      this.commit("shopee/calcStoreUnread", shop_id);
    },
    invitationSession: function (state, data) {
      let shop_id = data.store.shop_id;
      let invition = state.sessionData[shop_id]['invition'].data;
      for (let i=0; i<invition.length; i++) {
        if (invition[i].id == data.from_session_id) {
          state.sessionData[shop_id]['invition'].data.splice(i, 1);
          break;
        }
      }
      if (data.to_session) {
        state.sessionData[shop_id]['recently'].data.unshift(data.to_session);
        this.commit("shopee/sortSessionList", {
          shop_id: shop_id,
          tab: 'recently'
        });
      }
    },
    transferSession: function (state, data) {
      let shop_id = data.store.shop_id;
      let tab = '';
      let list = null;
      for (let j=0; j<state.sessionTab.length; j++) {
        tab = state.sessionTab[j];
        list = state.sessionData[shop_id][tab].data;
        for (let i=0; i<list.length; i++) {
          if (list[i].id == data.from_session_id) {
            state.sessionData[shop_id][tab].data.splice(i, 1);
            break;
          }
        }
      }
      if (data.to_session) {
        this.commit("shopee/updateSession", {
          tab: 'recently',
          session_detail: data.to_session,
          sync_type: 'MESSAGE_UPDATE'
        });
      }
    },
    // 设置消息id
    setMessageId: function (state, data) {
      let msgLen = state.messageData[data.shop_id].messages.length - 1;
      for (let i=msgLen; i>=0; i--) {
        if ( state.messageData[data.shop_id].messages[i].message_id == data.temp_message_id ) {
          state.messageData[data.shop_id].messages[i].message_id = data.message_id;
          break;
        }  
      }
    },
    setMessageTxt: function (state, data) {
      let msgLen = state.messageData[data.shop_id].messages.length - 1;
      for (let i=msgLen; i>=0; i--) {
        if ( state.messageData[data.shop_id].messages[i].message_id == data.temp_message_id ) {
          console.log(state.messageData[data.shop_id].messages[i]);
          state.messageData[data.shop_id].messages[i].format_content = data.transTxt;
          break;
        }  
      }
    },
    // 会话列表排序
    sortSessionList: function (state, data) {
      let tabs = [];
      if (!data.tab) {
        tabs = state.sessionTab;
      } else {
        tabs = [data.tab];
      }
      for (let i=0; i<tabs.length; i++) {
        state.sessionData[data.shop_id][tabs[i]].data.sort(function (a, b) {
          if (b.unread_count != a.unread_count) {
            return b.unread_count - a.unread_count;
          } else if (b.transfer_mark != a.transfer_mark) {
            return b.transfer_mark - a.transfer_mark;
          } else {          
            return b.last_message_timestamp - a.last_message_timestamp;
          }
        });
      }
    },
    // 计算未读消息
    calcStoreUnread: function (state, shop_id) {
      let unread_count = 0;
      let transfer_count = 0;
      for (let j=0; j<state.sessionTab.length; j++) {
        let session_list = state.sessionData[shop_id][state.sessionTab[j]].data;
        for (let i=0; i < session_list.length; i++)
        {
          unread_count += session_list[i]['unread_count'];
          transfer_count += session_list[i]['transfer_mark'];
        }
      }
      Vue.set(state.storeData, shop_id, {unread_count: unread_count, transfer_count: transfer_count});
      for (let j=0; j<state.storeList.length; j++) {
        if (shop_id == state.storeList[j].shop_id) {
          state.storeList[j].unread_count = unread_count;
          state.storeList[j].transfer_count = transfer_count;
          break;
        }
      }
      state.storeList.sort(function (a, b) {
        if (b.unread_count == a.unread_count) {
          return b.transfer_count - a.transfer_count;
        } else {        
          return b.unread_count - a.unread_count;
        }
      })
    },
    messageHanle: function (state, data) {
      if (data.receive_type == 'conversation') {
        // 会话分配给当前客服
        let shop_id = data.session_detail.shop_id;
        let invition = state.sessionData[shop_id]['invition'].data;
        for (let i=0; i<invition.length; i++) {
          if (invition[i].id == data.session_detail.id) {
            state.sessionData[shop_id]['invition'].data.splice(i, 1);
            break;
          }
        }
        data.tab = 'recently';
        this.commit("shopee/updateSession", data);
      } else if (data.receive_type == 'notice') {
        // 会话提示
        let shop_id = data.session_detail.shop_id;
        if (data.session_detail.csr) {
          // 该会话已分配，从未分配里移除
          let invition = state.sessionData[shop_id]['invition'].data;
          for (let i=0; i<invition.length; i++) {
            if (invition[i].id == data.session_detail.id) {
              state.sessionData[shop_id]['invition'].data.splice(i, 1);
              break;
            }
          }
          // 当前客服是主管则都显示在已分配
          // if (state.user.chat_privilege) {
            data.tab = 'recently';
            this.commit("shopee/updateSession", data);
          // }
        } else {
          data.tab = 'invition';
          this.commit("shopee/updateSession", data);
        }
      }
    },
    updateSession: function (state, sessionData) {
      let tabs = sessionData.tab ? [sessionData.tab] : ['invition', 'recently'];
      let session = sessionData.session_detail;
      let notice = false;
      let flag = true;
      let session_list = null;
      let tab = '';
      for (let j=0; j<tabs.length; j++) {
        tab = tabs[j];
        session_list = state.sessionData[session.shop_id][tab].data;

        for (let i=0; i<session_list.length; i++) {
          if (session_list[i].conversation_id == session.conversation_id) {
            flag = false;
            if ( session.unread_count > session_list[i].unread_count ) {
              notice = true;
            }
            state.sessionData[session.shop_id][tab].data[i] = session;
          }
        }
        if (flag && (sessionData.sync_type && sessionData.sync_type != 'SESSION_UPDATE')) {
          state.sessionData[session.shop_id][tab].data.push(session);
          notice = true;
        }
        this.commit("shopee/calcStoreUnread", session.shop_id);
        this.commit("shopee/sortSessionList", {
          shop_id: session.shop_id,
          tab: tab
        });
      }
      if (notice) {
        Audio.tingNotice();
      }
    },
    updateMessage: function (state, session) {
      if (session.data.type != 'message') {
        return false;
      }

      let currentSession = state.currentSessionData[state.currentStore.shop_id];
      let messageData = state.messageData[state.currentStore.shop_id];
      if (currentSession && currentSession.conversation_id == session.data.content.conversation_id) {

        let flag = true;
        for (let i=0; i<messageData.messages.length; i++) {
          if (messageData.messages[i].message_id == session.data.content.message_id) {
            flag = false;
          }
        }
        if (flag && session.data.content) {
          let sessiondata = session.data.content;
          sessiondata.format_content = messageFormat2(sessiondata.message_type, sessiondata.content);
          sessiondata.sys_notice = sessiondata.message_type == 2 ? 1 : 0;
          sessiondata.timestamp = formatDateTime(new Date(sessiondata.created_timestamp));
          
          if (sessiondata.from_id != currentSession.to_id) {
            sessiondata.avatar = state.currentStore.logo_url;
          } else {          
            sessiondata.avatar = currentSession.to_avatar;
          }
          
          state.messageData[state.currentStore.shop_id].messages.push(sessiondata);
          EventBus.$emit('shopeeAddmsgCallback');
          this.commit("shopee/msgCallback", sessiondata);
          this.commit("shopee/sortMessage");
          // 翻译
          if (store.state.translate) {
            this.commit("shopee/getTransMessage");
          }
        }
      }
    },
    sortMessage: function (state) {
      state.messageData[state.currentStore.shop_id].messages.sort(function (a, b) {
        return a.send_time - b.send_time;
      });
    },
    // 添加消息
    pushMessageList: function (state, msgData) {
      let self = this;
      let dealMsg = new Array();
      let currentSession = state.currentSessionData[state.currentStore.shop_id];
      let messageData = state.messageData[state.currentStore.shop_id];
      let messages = msgData.messages;
      messages = messages.map(function(elem) {
        elem.format_content = messageFormat2(elem.message_type, elem.content);
        elem.sys_notice = elem.template_id == 2 ? 1 : 0;
        elem.timestamp = formatDateTime(new Date(elem.send_time));

        if (elem.from_id != currentSession.to_id) {
          elem.avatar = state.currentStore.logo_url;
        } else {          
          elem.avatar = currentSession.to_avatar;
        }
        if (elem.from_id != currentSession.to_id) {
          elem.avatar = state.currentStore.logo_url;
        } else {          
          elem.avatar = currentSession.to_avatar;
        }
        if (elem.source_content.item_id && elem.message_type != 'offer') {
          elem.productOfConsult = {
            shop_id: '',
            item_id: '',
            images: [],
            name: '-',
            original_price: '-',
            price: '-',
            stock: '-'
          }
        } else if (elem.source_content.order_sn) {
          elem.orderOfConsult = {
            shop_id: '',
            item_id: '',
            images: [],
            name: '-',
            original_price: '-',
            price: '-',
            stock: '-'
          }
        }
        if ((elem.source_content.item_id && elem.message_type != 'offer') || elem.source_content.order_sn) {
          dealMsg.push(elem);
        } else {        
          self.commit("shopee/msgCallback", elem);
        }
        return elem;
      });

      for (let i=0; i<messageData.messages.length; i++)
      {      
        messages.push(messageData.messages[i]);
      }
      state.messageData[state.currentStore.shop_id].messages = messages;
      state.messageData[state.currentStore.shop_id].page_result = msgData.page_result;
      for (let i=0; i<dealMsg.length; i++) {
        if (dealMsg[i].source_content.item_id) {
          let param = new FormData();
          param.set("store_id", state.currentStore.id);
          param.set("item_id", dealMsg[i].source_content.item_id);
          RequestUtils.request(conf.getProductInfo(), param).then(json => {
            dealMsg[i].productOfConsult = json;
          })
        } else if (dealMsg[i].source_content.order_sn) {
          let param = new FormData();
          param.set("store_id", state.currentStore.id);
          param.set("order_sn", dealMsg[i].source_content.order_sn);
          RequestUtils.request(conf.getOrder(), param).then(json => {
            dealMsg[i].orderOfConsult = json;
          })
        }
      }
      if (store.state.translate) {
        this.commit("shopee/getTransMessage");
      }
    },
    addMessage: function(state, message) {

      let currentSession = state.currentSessionData[state.currentStore.shop_id];
      let data = {
        content: message.content,
        conversation_id: currentSession.conversation_id,
        created_timestamp: message.created_timestamp,
        from_id: currentSession.shop_id,
        from_shop_id: currentSession.shop_id,
        message_id: message.message_id,
        message_type: message.message_type,
        region: "TH",
        source: "openapi",
        status: "normal",
        to_id: message.to_id,
      }
      if (message.content.trans_result) {
        data.trans_result = message.content.trans_result;
      }
      let msg = {
        shop_id: state.currentStore.shop_id,
        data: {
          type: 'message',
          content: data
        }
      }
      this.commit("shopee/updateMessage", msg);
    },
    // 已读会话
    resetUnRead: function(state) {
      let currentSession = state.currentSessionData[state.currentStore.shop_id];
      let conversations = state.sessionData[ state.currentStore.shop_id ].recently.data;;
      for (let i=0; i < conversations.length; i++) {
        if (conversations[i].conversation_id == currentSession.conversation_id) {
          state.sessionData[ state.currentStore.shop_id ].recently.data[i].unread_count = 0;
          break;
        }
      }
      this.commit("shopee/calcStoreUnread", state.currentStore.shop_id);
    },
    msgCallback (state, message) {
      let messageData = state.messageData[state.currentStore.shop_id];
      if (message.message_type == 'item') {
        let param = new FormData();
        param.set("store_id", state.currentStore.id);
        param.set("item_id", message.content.item_id);
        RequestUtils.request(conf.getProductInfo(), param).then(json => {
          console.log(json);
          for (let i=0; i<messageData.messages.length; i++) {
            if (messageData.messages[i].message_id == message.message_id) {
              let format_content = messageData.messages[i].format_content;
              state.messageData[state.currentStore.shop_id].messages[i].format_content = format_content
              .replace(/{{title}}/gi, json.product_title)
              .replace(/{{actionUrl}}/gi, json.url)
              .replace(/{{price}}/gi, json.special_price+' '+json.currency)
              .replace(/{{oldPrice}}/gi, json.price)
              .replace(/{{discount}}/gi, ((json.price - json.special_price)/json.special_price)*100)
              .replace(/{{iconUrl}}/gi, json.images[0]);
              return;
            }
          }
        })
      } else if (message.message_type == 'order') {
        let param = new FormData();
        param.set("store_id", state.currentStore.id);
        param.set("order_sn", message.content.order_sn);
        RequestUtils.request(conf.getOrder('shopee'), param).then(json => {
          let order = json;
          if (order) {
            for (let i=0; i<messageData.messages.length; i++) {
              if (messageData.messages[i].message_id == message.message_id) {
                let format_content = messageData.messages[i].format_content;
                state.messageData[state.currentStore.shop_id].messages[i].format_content = format_content
                .replace(/{{orderId}}/gi, order.order_sn)
                .replace(/{{iconUrl}}/gi, order.item_list[0].image_info.image_url)
                .replace(/{{productName}}/gi, order.item_list[0].item_name)
                .replace(/{{status}}/gi, order.order_status)
                .replace(/{{content}}/gi, formatDateTime(new Date(order.create_time*1000)) );
                return;
              }
            }
          }
        })
      } else if (message.message_type == 'offer') {
        let param = new FormData();
          param.set("store_id", state.currentStore.id);
          param.set("offer_id", message.content.offer_id);
          param.set("message_id", message.message_id);
          RequestUtils.request(conf.getOfferDetail(), param).then(json => {
            console.log(json)
            for (let i=0; i<messageData.messages.length; i++) {
              if (messageData.messages[i].message_id == message.message_id) {
                let format_content = messageData.messages[i].format_content;
                state.messageData[state.currentStore.shop_id].messages[i].format_content = format_content
                .replace(/{{image}}/gi, json.item.image)
                .replace(/{{itemName}}/gi, json.item.item_name)
                .replace(/{{offerPrice}}/gi, json.offer_price)
                .replace(/{{quantity}}/gi, json.product_count)
                .replace(/{{totalPrice}}/gi, json.product_count*json.offer_price );
                return;
              }
            }
          })
      }
    },
    // 查询会话
    setSearchSession: function (state, data) {
      console.log(data);
      if (data == null) {
        state.searchSession = {load: 2};
      } else {      
        data.load = data.total == 0 ? 1 : 3;
        if (data.current_page == 1) {        
          state.searchSession = data;
        } else {
          console.log(state.searchSession);
          for (let i=0; i<data.data.length; i++) {
            state.searchSession.data.push(data.data[i]); 
          }
          state.searchSession.current_page = data.current_page;
          state.searchSession.last_page = data.last_page;
        }
      }
    },
    /**
     * 设置订单数据
     * @param {[type]} state [description]
     * @param {[type]} data  [description]
     */
    setOrderData: function (state, data) {
      let shop_id = state.currentStore.shop_id;
      if (data == null) {
        state.orderData[shop_id] = {load: 2};
      } else {      
        for (let i=0; i<data.data.length; i++) {
          data.data[i].moreshow = false;
        }
        data.load = data.total == 0 ? 1 : 3;
        if (data.current_page == 1) {        
          state.orderData[shop_id] = data;
        } else {
          for (let i=0; i<data.data.length; i++) {
            state.orderData[shop_id].data.push(data.data[i]); 
          }
          state.orderData.current_page = data.current_page;
          state.orderData.last_page = data.last_page;
        }
      }
    },
    orderMoreShow: function (state, index) {
      let shop_id = state.currentStore.shop_id;
      state.orderData[shop_id].data[index].moreshow = !state.orderData[shop_id].data[index].moreshow;
    },
    /**
     * 设置产品数据
     * @param {[type]} state [description]
     * @param {[type]} data  [description]
     */
    setProductData: function (state, data) {
      let shop_id = state.currentStore.shop_id;
      if (data == null) {
        state.productData[shop_id] = {load: 2};
      } else {      
        data.load = data.total == 0 ? 1 : 3;
        if (data.current_page == 1) {        
          state.productData[shop_id] = data;
        } else {
          for (let i=0; i<data.data.length; i++) {
            state.productData[shop_id].data.push(data.data[i]); 
          }
          state.productData[shop_id].current_page = data.current_page;
          state.productData[shop_id].last_page = data.last_page;
        }
      }
    },
    setOrderValue: function (state, data) {
      let shop_id = state.currentStore.shop_id;
      for (let key in data) {
        state.orderData[shop_id][key] = data[key];
      }
    },
    setProductValue: function (state, data) {
      let shop_id = state.currentStore.shop_id;
      for (let key in data) {
        state.productData[shop_id][key] = data[key];
      }
    },
    // 优惠券
    setVoucherData: function (state, data) {
      let shop_id = state.currentStore.shop_id;
      if (data == null) {
        state.voucherData[shop_id] = {load: 2};
      } else {
        data.load = data.voucher_list.length > 0 ? 3 : 1;
        state.voucherData[shop_id] = data;
      }
    },
    // 打开会话
    openSession(state, data) {
      let param = new FormData();
      param.set("store_id", data.store_id);
      param.set("buyer_id", data.buyer_id);

      RequestUtils.request(conf.openSession('shopee'), param, {loading: true}).then(json => {
        EventBus.$emit('setPlatform', 'shopee');
        for (let i=0; i<state.storeList.length; i++) {
          if (state.storeList[i].id == data.store_id) {          
            console.log(state.storeList[i]);
            this.commit("shopee/setCurrentStore", state.storeList[i]);
          }
        }
        this.commit("shopee/updateSession", {session_detail: json.session, tab: 'recently'});
        this.commit("shopee/setCurrentSessionData", json.session);
        EventBus.$emit('shopeeOpenSession', json.session);
      })
    },
    /**
     * 获取需要翻译的消息
     * @param  {[type]} state [description]
     * @return {[type]}       [description]
     */
    getTransMessage(state) {
      let transQuerys = new Array();
      let messages = state.messageData[state.currentStore.shop_id].messages;
      messages.map(function (elem) {
        if ( elem.message_type == 'text' && !elem.trans_result ) {
          transQuerys.push({
            'src': elem.content.text,
            'message_id': elem.message_id
          });
        }
      })
      this.commit("shopee/translateMessage", transQuerys);
    },
    /**
     * 翻译消息
     * @param  {[type]} state [description]
     * @param  {[type]} data  [description]
     * @return {[type]}       [description]
     */
    translateMessage(state, transQuerys) {
      if (transQuerys.length == 0) return false;
      let param = new FormData();
      param.set("querys", JSON.stringify(transQuerys));
      param.set("to", 'zh');
      param.set("connector", 'shopee');

      RequestUtils.request(conf.translantText(), param)
      .then(json => {
        let messageData = state.messageData[state.currentStore.shop_id];
        messageData = JSON.parse(JSON.stringify(messageData));
        json.trans_result.map(function(elem) {
          for (let i=0; i<messageData.messages.length; i++)
          {
            if ( messageData.messages[i].message_id == elem.message_id ) {
              messageData.messages[i].trans_result = {"zh": elem.dst};
            } 
          }
        })
        Vue.set(state.messageData, state.currentStore.shop_id, messageData);
      })
    },
    setUser: function(state, user) {
      state.user = user;
    },
    // 退出登录
    closeConnect: function(state) {
      state.websocket.heartReset();
      state.websocket.close();
    },
    // 退出后清除内存中的聊天信息
    clear: function(state) {
      state.storeList = [];
      state.storeData = {};
      state.sessionData = {};
      state.messageData = {};
      state.currentSessionData = {};
      state.currentStore = {};
      state.sellerData = {};
    },
    setMessageList: function(state, messageList) {
      state.messageList = messageList;
    },
    resetData: function (state) {
      state.currentSessionData = {};
      state.currentStore = {};
    }
   
  },
  actions: {              // actions提交mutations

  },
  modules: {  //子模块，一般在主模块中用到
  
  }
  
}